// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"527":"b545020b","601":"56c7d7ac","754":"d08e3c5d"}[chunkId] + ".js";
};